import { UpdateOutletFormInstance } from '../types';

export const validateForm = async (instance: UpdateOutletFormInstance) => {
  let isValid = true;
  const errors: Partial<Record<keyof UpdateOutletFormInstance, string>> = {};

  if (instance.status.id === 2 || instance.status.id === 3 || instance.status.id === 4) {
    if (instance.outlet.count_equipment > 0) {
      errors.status = 'Нельзя изменить статус ТТ при наличии холодильников';
      isValid = false;
    }
  }
  
  if (!instance.name) {
    errors.title = 'Не указано название ТТ';
    isValid = false;
  }
  if (!instance.title) {
    errors.title = 'Не указана вывеска';
    isValid = false;
  }

  if (!instance.distributor) {
    errors.distributor = 'Не указан дистрибьютор';
    isValid = false;
  }

  if (instance.sub_channel === undefined || instance.sub_channel === null) {
    errors.sub_channel = 'Не указана Канал/Подканал';
    isValid = false;
  }
  if (!instance.visits_day) {
    errors.visits_day = 'Не указан день визита';
    isValid = false;
  }
  if (!instance.route_number) {
    errors.route_number = 'Не указан номер маршрута';
    isValid = false;
  }

  if (!instance.address) {
    errors.address = 'Не указана факт. адрес';
    isValid = false;
  }
 
  return {
    isValid,
    errors,
  };
};
